import Link from '@stories/Elements/Forms/Buttons/Link';
import React, { FunctionComponent } from 'react';
import { PromoCardStyles } from './PromoCard.styles';

export type ViewModel = ListingCardModel & {
  textTheme?: number;
};

export interface PromoCardProps {
  viewModel: ViewModel;
}

const PromoCard: FunctionComponent<PromoCardProps> = (props) => {
  const isLongText = props.viewModel.title.split(' ').filter((w) => w.length >= 15).length > 0;

  const getLinkTheme = (cardTheme: number): string => {
    switch (cardTheme) {
      case 0:
        return 'black';
      case 1:
        return 'white';
      case 2:
        return 'red';
      default:
        return 'black';
    }
  };

  return (
    <PromoCardStyles.Card showBorder={!!props.viewModel.newTagText} data-theme={props.viewModel.textTheme}>
      {props.viewModel.imageUrl ? (
        <PromoCardStyles.Background src={props.viewModel.imageUrl} role="presentation" />
      ) : null}
      {props.viewModel.videoUrl ? (
        <PromoCardStyles.BackgroundVideo src={props.viewModel.videoUrl} autoPlay={true} loop muted playsInline />
      ) : null}
      <PromoCardStyles.Inner>
        {props.viewModel.showNewTag ? <PromoCardStyles.Tag>{props.viewModel.newTagText}</PromoCardStyles.Tag> : null}
        <PromoCardStyles.Title isLongText={isLongText}>{props.viewModel.title}</PromoCardStyles.Title>
        {!props.viewModel.hideButton ? (
          <Link
            theme={getLinkTheme(props.viewModel.cardTheme)}
            text={props.viewModel.buttonText}
            href={props.viewModel.url}
            target={props.viewModel.isExternalUrl ? '_blank' : '_self'}
            size="small"
          />
        ) : null}
      </PromoCardStyles.Inner>
    </PromoCardStyles.Card>
  );
};

export default PromoCard;
